(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[896],{

/***/ 8679:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(59864);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 68517:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/become-a-tutor",
      function () {
        return __webpack_require__(74832);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1821:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ AuthRegistrationForm; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97346);
/* harmony import */ var react_bootstrap_Button__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(35005);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82175);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74231);
/* harmony import */ var _utils_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18382);
/* harmony import */ var _utils_urlHelpers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(12367);
/* harmony import */ var react_phone_input_2__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67555);
/* harmony import */ var react_phone_input_2__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react_phone_input_2__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_phone_input_2_lib_bootstrap_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7544);
/* harmony import */ var react_phone_input_2_lib_bootstrap_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react_phone_input_2_lib_bootstrap_css__WEBPACK_IMPORTED_MODULE_5__);









function AuthRegistrationForm(param) {
    let { onSubmit , onCancel , requestMobilePhone =false  } = param;
    let validationObject = {
        firstName: (0,yup__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_)().required(),
        lastName: (0,yup__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_)().required(),
        email: (0,yup__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_)().email().required(),
        password: (0,yup__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_)().required(),
        termsAcceptance: (0,yup__WEBPACK_IMPORTED_MODULE_2__/* .mixed */ .nK)().required()
    };
    if (requestMobilePhone) {
        validationObject.mobilePhone = (0,yup__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_)().required();
    }
    const validationSchema = (0,yup__WEBPACK_IMPORTED_MODULE_2__/* .object */ .Ry)(validationObject);
    const formik = (0,formik__WEBPACK_IMPORTED_MODULE_1__/* .useFormik */ .TA)({
        initialValues: {
            firstName: "",
            lastName: "",
            email: "",
            password: "",
            mobilePhone: ""
        },
        validationSchema,
        onSubmit: async (values)=>{
            try {
                await onSubmit(values);
            } catch (e) {
                formik.setErrors((0,_utils_api__WEBPACK_IMPORTED_MODULE_3__/* .apiErrorsToFormik */ .p)(e));
            } finally{
                formik.setSubmitting(false);
            }
        }
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        onSubmit: formik.handleSubmit,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Group */ .Z.Group, {
                controlId: "firstName",
                className: "mb-3",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Label */ .Z.Label, {
                        children: "First Name"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Control */ .Z.Control, {
                        name: "firstName",
                        isInvalid: formik.errors.firstName,
                        onChange: formik.handleChange
                    }),
                    formik.errors.firstName && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Control.Feedback */ .Z.Control.Feedback, {
                        type: "invalid",
                        children: formik.errors.firstName
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Group */ .Z.Group, {
                controlId: "lastName",
                className: "mb-3",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Label */ .Z.Label, {
                        children: "Last Name"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Control */ .Z.Control, {
                        name: "lastName",
                        isInvalid: formik.errors.lastName,
                        onChange: formik.handleChange
                    }),
                    formik.errors.lastName && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Control.Feedback */ .Z.Control.Feedback, {
                        type: "invalid",
                        children: formik.errors.lastName
                    })
                ]
            }),
            requestMobilePhone && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Group */ .Z.Group, {
                controlId: "mobilePhone",
                className: "mb-3",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Label */ .Z.Label, {
                        children: "Phone Number"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_phone_input_2__WEBPACK_IMPORTED_MODULE_4___default()), {
                        country: "gb",
                        regions: "europe",
                        containerClass: formik.errors.mobilePhone ? "is-invalid" : "",
                        inputClass: formik.errors.mobilePhone ? "is-invalid" : "",
                        onChange: (value)=>{
                            formik.setFieldValue("mobilePhone", value);
                        }
                    }),
                    formik.errors.mobilePhone && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Control.Feedback */ .Z.Control.Feedback, {
                        type: "invalid",
                        children: formik.errors.mobilePhone
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Group */ .Z.Group, {
                controlId: "email",
                className: "mb-3",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Label */ .Z.Label, {
                        children: "Email"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Control */ .Z.Control, {
                        name: "email",
                        type: "email",
                        isInvalid: formik.errors.email,
                        onChange: formik.handleChange
                    }),
                    formik.errors.email && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Control.Feedback */ .Z.Control.Feedback, {
                        type: "invalid",
                        children: formik.errors.email
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Group */ .Z.Group, {
                controlId: "password",
                className: "mb-3",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Label */ .Z.Label, {
                        children: "Password"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Control */ .Z.Control, {
                        name: "password",
                        type: "password",
                        isInvalid: formik.errors.password,
                        onChange: formik.handleChange
                    }),
                    formik.errors.password && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Control.Feedback */ .Z.Control.Feedback, {
                        type: "invalid",
                        children: formik.errors.password
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Group */ .Z.Group, {
                controlId: "termsAcceptance",
                className: "mb-3",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Check */ .Z.Check, {
                    type: "checkbox",
                    name: "termsAcceptance",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Check.Input */ .Z.Check.Input, {
                            type: "checkbox",
                            value: true,
                            isInvalid: formik.errors.termsAcceptance,
                            onChange: formik.handleChange
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Check.Label */ .Z.Check.Label, {
                            children: [
                                "I accept the",
                                " ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: "".concat((0,_utils_urlHelpers__WEBPACK_IMPORTED_MODULE_7__/* .appUrl */ .G)("legal/terms")),
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: "Terms & Conditions"
                                }),
                                " ",
                                "and",
                                " ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: "".concat((0,_utils_urlHelpers__WEBPACK_IMPORTED_MODULE_7__/* .appUrl */ .G)("legal/privacy")),
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: "Privacy Policy"
                                })
                            ]
                        }),
                        formik.errors.termsAcceptance && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Control.Feedback */ .Z.Control.Feedback, {
                            type: "invalid",
                            children: formik.errors.termsAcceptance
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "text-end",
                children: [
                    onCancel && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Button__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        variant: "outline-secondary",
                        onClick: onCancel,
                        className: "me-2",
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Button__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        type: "submit",
                        disabled: formik.isSubmitting,
                        children: "Register"
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 74832:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ BecomeATutor; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./public/images/tutor_business.svg
/* harmony default export */ var tutor_business = ({"src":"/_next/static/media/tutor_business.bcdf36ad.svg","height":795,"width":1091});
;// CONCATENATED MODULE: ./public/images/tutor_control_schedule.svg
/* harmony default export */ var tutor_control_schedule = ({"src":"/_next/static/media/tutor_control_schedule.6e8d12a6.svg","height":756,"width":955});
;// CONCATENATED MODULE: ./public/images/tutor_revenue.svg
/* harmony default export */ var tutor_revenue = ({"src":"/_next/static/media/tutor_revenue.291d663f.svg","height":715,"width":974});
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(10682);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Card.js + 2 modules
var Card = __webpack_require__(78182);
// EXTERNAL MODULE: ./components/BecomeATutorHero.module.scss
var BecomeATutorHero_module = __webpack_require__(27931);
var BecomeATutorHero_module_default = /*#__PURE__*/__webpack_require__.n(BecomeATutorHero_module);
;// CONCATENATED MODULE: ./public/images/become-tutor-bg.jpg
/* harmony default export */ var become_tutor_bg = ({"src":"/_next/static/media/become-tutor-bg.b30c32be.jpg","height":1280,"width":1920,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAeEAABBAIDAQAAAAAAAAAAAAABAAIDEQQGBRJhQf/EABUBAQEAAAAAAAAAAAAAAAAAAAID/8QAFxEBAQEBAAAAAAAAAAAAAAAAAQIAEf/aAAwDAQACEQMRAD8Ah7Rzmbh7GWQzSNEBd0AeQAL8+3RvxERWIGnuDSBv/9k=","blurWidth":8,"blurHeight":5});
// EXTERNAL MODULE: ./components/auth/RegistrationForm.js
var RegistrationForm = __webpack_require__(1821);
// EXTERNAL MODULE: ./utils/jsonApiClient.js + 1 modules
var jsonApiClient = __webpack_require__(42882);
// EXTERNAL MODULE: ./utils/auth.js
var auth = __webpack_require__(46180);
// EXTERNAL MODULE: ./utils/urlHelpers.js
var urlHelpers = __webpack_require__(12367);
;// CONCATENATED MODULE: ./components/BecomeATutorHero.js












function BecomeATutorHero() {
    const submitForm = async (attrs)=>{
        const jsonApi = (0,jsonApiClient/* default */.Z)();
        // @Note: No try/catch here as RegistrationForm applies errors to the form
        await jsonApi.create("user", {
            ...attrs,
            roleName: "tutor"
        }, {
            include: "profile"
        });
        try {
            const { email , password  } = attrs;
            await (0,auth/* signIn */.zB)({
                email,
                password
            });
            window.location.replace((0,urlHelpers/* appUrl */.G)("account/dashboard"));
        } catch (e) {
            console.log(e);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (BecomeATutorHero_module_default()).heroContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (BecomeATutorHero_module_default()).overlay
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: become_tutor_bg,
                className: (BecomeATutorHero_module_default()).backgroundImage,
                alt: "Cover photo",
                priority: true,
                fill: true,
                sizes: "100vw",
                style: {
                    objectFit: "cover",
                    objectPosition: "center"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                className: "".concat((BecomeATutorHero_module_default()).content, " pt-lg-4 pb-4"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                    className: "mt-md-5",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: "loud-header text-white",
                                    children: "Begin Tutoring Today"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                        xs: 12,
                                        md: 8,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "text-white mt-md-5",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "font-weight-bold",
                                                    children: "Join our community of tutors. Run your tutoring business on Tutorspot or simply tutor a few students part-time. You choose!"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "We help both new and experienced tutors find students, manage schedules and collect payments."
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            xs: 12,
                            md: 4,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                                className: "mb-md-5",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Body */.Z.Body, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RegistrationForm/* default */.Z, {
                                        onSubmit: submitForm
                                    })
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./pages/become-a-tutor.js










function BecomeATutor() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: "Become a Tutor | Tutorspot"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BecomeATutorHero, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                    className: "mt-5 text-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            xs: 12,
                            md: 4,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "p-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: tutor_business,
                                        width: 300,
                                        height: 200,
                                        style: {
                                            maxWidth: "100%",
                                            height: "auto"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mt-5",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                children: "Build Your Tutoring Business"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-secondary",
                                                children: "We will advertise your profile so potential students can message you"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            xs: 12,
                            md: 4,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "p-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: tutor_control_schedule,
                                        width: 300,
                                        height: 200,
                                        style: {
                                            maxWidth: "100%",
                                            height: "auto"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mt-5",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                children: "Be in Control"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-secondary",
                                                children: "Choose the subjects you tutor and your rate according to your qualifications and experience"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            xs: 12,
                            md: 4,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "p-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: tutor_revenue,
                                        width: 300,
                                        height: 200,
                                        style: {
                                            maxWidth: "100%",
                                            height: "auto"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mt-5",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                children: "Easy, Straightforward Payments"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-secondary",
                                                children: "We pay you weekly for all of your lessons so you can focus on your students"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
}


/***/ }),

/***/ 18382:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ fetchRecordBySlug; },
/* harmony export */   "p": function() { return /* binding */ apiErrorsToFormik; }
/* harmony export */ });
/* harmony import */ var _jsonApiClient__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42882);

function apiErrorsToFormik(e) {
    let formikErrors = {};
    Object.keys(e).map((field)=>formikErrors[field] = e[field].detail.replace("".concat(field, " - "), ""));
    return formikErrors;
}
async function fetchRecordBySlug(recordType, slug) {
    const jsonApi = (0,_jsonApiClient__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
    const { data , errors  } = await jsonApi.findAll(recordType, {
        filter: {
            slug
        }
    });
    if (errors) return errors;
    if (data) return data[0];
}


/***/ }),

/***/ 27931:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"heroContainer":"BecomeATutorHero_heroContainer__nMIrm","overlay":"BecomeATutorHero_overlay__wwZv8","backgroundImage":"BecomeATutorHero_backgroundImage__zeX8x","content":"BecomeATutorHero_content__e_qe9"};

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(83121)


/***/ }),

/***/ 53439:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ed": function() { return /* binding */ forEach; },
/* harmony export */   "UI": function() { return /* binding */ map; },
/* harmony export */   "XW": function() { return /* binding */ hasChildOfType; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/**
 * Iterates through children that are typically specified as `props.children`,
 * but only maps over children that are "valid elements".
 *
 * The mapFunction provided index will be normalised to the components mapped,
 * so an invalid component would not increase the index.
 *
 */

function map(children, func) {
  let index = 0;
  return react__WEBPACK_IMPORTED_MODULE_0__.Children.map(children, child => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(child) ? func(child, index++) : child);
}
/**
 * Iterates through children that are "valid elements".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 */


function forEach(children, func) {
  let index = 0;
  react__WEBPACK_IMPORTED_MODULE_0__.Children.forEach(children, child => {
    if ( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(child)) func(child, index++);
  });
}
/**
 * Finds whether a component's `children` prop includes a React element of the
 * specified type.
 */


function hasChildOfType(children, type) {
  return react__WEBPACK_IMPORTED_MODULE_0__.Children.toArray(children).some(child => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(child) && child.type === type);
}



/***/ }),

/***/ 69921:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 59864:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(69921);
} else {}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [687,774,888,179], function() { return __webpack_exec__(68517); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);